import '../services.css';

const Staffing = () => {
    return (
        <div className="cover w-100">
            {/* Hero Section */}
            <div className="service-hero-section text-white py-5 text-center bg-primary">
                <h1 className="display-4 fw-bold mb-3">Staffing Solutions</h1>
            </div>

            {/* Main Description Section */}
            <div className="container py-5">
                <div className="row align-items-center">
                    {/* Left - Text */}
                    <div className="col-md-8 mb-4 mb-md-0">
                        <p className="text-justify">
                            Our comprehensive staffing services connect you with the right talent—whether temporary, permanent, or contract-based. We ensure a perfect match for your project needs, company culture, and long-term goals through a seamless and transparent hiring process.
                        </p>
                    </div>

                    {/* Right - Image */}
                    <div className="image-area col-md-4 text-center text-md-end h-100">
                        <img
                            src="assets/images/service/staffing-solution.png"
                            alt="Staffing Solutions"
                            style={{ width: '100%', height: 'auto', objectFit: 'contain' }}
                        />
                    </div>
                </div>
            </div>

            {/* Additional Sections */}
            <div className="container py-2  ">
                {/* Temporary Staffing */}
                <div className="mb-5">
                    <h3 className="h4 fw-semibold mb-3">Temporary Staffing</h3>
                    <p className="text-justify">
                        Flexible and cost-effective workforce solutions to help you scale quickly for seasonal demands or short-term projects.
                    </p>
                </div>

                {/* Permanent Hiring */}
                <div className="mb-5">
                    <h3 className="h4 fw-semibold mb-3">Permanent Hiring</h3>
                    <p className="text-justify">
                        We identify long-term talent that aligns with your company culture and strategic goals, ensuring lasting success.
                    </p>
                </div>

                {/* Contract Staffing */}
                <div className="mb-5">
                    <h3 className="h4 fw-semibold mb-3">Contract Staffing</h3>
                    <p className="text-justify">
                        Get access to skilled professionals for defined project durations without long-term commitments or overheads.
                    </p>
                </div>

                {/* IT Staffing */}
                <div className="mb-4">
                    <h3 className="h4 fw-semibold mb-3">IT Staffing</h3>
                    <p className="text-justify">
                        We specialize in providing top-tier tech talent for software development, QA, cloud, DevOps, and more.
                    </p>
                </div>

                {/* Remote Staffing */}
                <div className="mb-4">
                    <h3 className="h4 fw-semibold mb-3">Remote Staffing</h3>
                    <p className="text-justify">
                        Build high-performing remote teams with professionals who are skilled, reliable, and ready to contribute from day one.
                    </p>
                </div>

                {/* Recruitment Process Outsourcing */}
                <div className="mb-4">
                    <h3 className="h4 fw-semibold mb-3">Recruitment Process Outsourcing (RPO)</h3>
                    <p className="text-justify">
                        Let us manage your recruitment operations end-to-end, improving efficiency and reducing hiring time and cost.
                    </p>
                </div>
            </div>
        </div>
    );
};

export default Staffing;
